/* ============================================================================
   Icons - inline SVG strings (stroke-based, inherit currentColor).
   Kept in one place so markup stays clean and icons stay consistent.
   Usage:  element.innerHTML = icon("search");
   ============================================================================ */

const P = {
  cookie:
    '<circle cx="12" cy="12" r="9"/><circle cx="9" cy="9" r=".6"/><circle cx="15" cy="10" r=".6"/><circle cx="10.5" cy="14" r=".6"/><circle cx="15" cy="14.5" r=".6"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  grid: '<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
  list: '<path d="M8 6h13M8 12h13M8 18h13"/><path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01"/>',
  vault:
    '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="12" cy="12" r="3.5"/><path d="M12 8.5v-1M12 16.5v-1"/>',
  download: '<path d="M12 3v12m0 0 4-4m-4 4-4-4"/><path d="M5 21h14"/>',
  map: '<path d="m9 4 6 2 5.2-2.1a.6.6 0 0 1 .8.6v13.1a1 1 0 0 1-.6.9L15 20l-6-2-5.2 2.1a.6.6 0 0 1-.8-.6V6.4a1 1 0 0 1 .6-.9L9 4Z"/><path d="M9 4v14M15 6v14"/>',
  logout: '<path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3"/><path d="M10 12H3m0 0 4-4m-4 4 4 4"/>',
  camera: '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>',
  check: '<path d="m4 12 5 5L20 6"/>',
  copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
  lock: '<rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  unlock: '<rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 7.5-1"/>',
  arrowUp: '<path d="M12 20V5m0 0-6 6m6-6 6 6"/>',
  external: '<path d="M14 5h5v5"/><path d="M19 5 10 14"/><path d="M19 14v3a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3"/>',
  sparkle:
    '<path fill="currentColor" stroke="none" d="M12 1.05c.22 4.05 1.85 6.7 4.85 8.4 3 1.7 5.1 2.55 5.1 2.55s-2.1.85-5.1 2.55c-3 1.7-4.63 4.35-4.85 8.4-.22-4.05-1.85-6.7-4.85-8.4C4.15 13.85 2.05 13 2.05 13s2.1-.85 5.1-2.55c3-1.7 4.63-4.35 4.85-8.4zM6.35 6.35l2.85 2.85-.7.7-2.85-2.85zm11.3 0l.7.7-2.85 2.85-.7-.7zm0 11.3l-2.85-2.85.7-.7 2.85 2.85zm-11.3 0l2.85-2.85.7.7-2.85 2.85z"/>',
  cake: '<path d="M4 14h16v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6Z"/><path d="M4 14c0-2.2 3.6-4 8-4s8 1.8 8 4"/><path d="M8 10V8.5M12 10V8.5M16 10V8.5"/><path d="M8 8.5c0-.8.4-1.5 1-1.5s1 .7 1 1.5M12 8.5c0-.8.4-1.5 1-1.5s1 .7 1 1.5M16 8.5c0-.8.4-1.5 1-1.5s1 .7 1 1.5"/><path d="M9 7l-.2-1.5M13 7l-.2-1.5M17 7l-.2-1.5"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>',
  alert: '<path d="M12 9v4m0 4h.01"/><path d="M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/>',
  heart: '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7 7-7Z"/>',
  bookmark: '<path d="M7 4.5h10a1 1 0 0 1 1 1V20l-6-3.5L6 20V5.5a1 1 0 0 1 1-1Z"/>',
  compass: '<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2 5-5 2 2-5 5-2Z"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>',
  female: '<circle cx="12" cy="7.5" r="3.5"/><path d="M12 11v8M9 15.5h6"/>',
  male: '<circle cx="9.5" cy="15" r="3.5"/><path d="M14.5 9.5 18.5 5.5M18.5 5.5H15M18.5 5.5V9"/>',
  femalePlus: '<circle cx="12" cy="7.8" r="4.2"/><path d="M12 12v7.5M8 16.5h8"/><path d="M16.5 4.5h2M17.5 3.5v2"/>',
  kids: '<circle cx="12" cy="9.5" r="2.7"/><path d="M7.5 19.5c0-2.6 2-4 4.5-4s4.5 1.4 4.5 4"/>',
  /* Classic 5-point star (TV inspired / ratings). Sparkle stays separate. */
  star:
    '<path fill="currentColor" stroke="none" d="M12 2.1l2.7 5.48 6.05.88-4.38 4.27 1.03 6.02L12 15.9l-5.4 2.85 1.03-6.02L3.25 8.46l6.05-.88L12 2.1z"/>',
  leaf:
    '<path fill="currentColor" stroke="none" d="M12 1.6C11.6 4.2 10.8 5.6 9.1 6.8 7.2 8.1 5.2 7.9 4.5 9.6 3.8 11.3 5.1 12.4 6.6 12.7 5.4 13.8 4.4 15.6 5.2 17.3 6.1 19.2 8.1 19 9.6 18.1 9.9 20.1 10.9 21.8 12 22.6 13.1 21.8 14.1 20.1 14.4 18.1 15.9 19 17.9 19.2 18.8 17.3 19.6 15.6 18.6 13.8 17.4 12.7 18.9 12.4 20.2 11.3 19.5 9.6 18.8 7.9 16.8 8.1 14.9 6.8 13.2 5.6 12.4 4.2 12 1.6Z"/>',
  teddyBear:
    '<circle cx="8.2" cy="7.8" r="1.8"/><circle cx="15.8" cy="7.8" r="1.8"/><circle cx="12" cy="10.5" r="4.2"/><circle cx="12" cy="11.5" r="1.1"/><path d="M8.5 15.2c0-2 1.6-3.6 3.5-3.6s3.5 1.6 3.5 3.6v5.2a2.8 2.8 0 0 1-5.6 0v-5.2Z"/><path d="M6.5 16.2v2.2M17.5 16.2v2.2"/>',
  outfit: '<path d="M12 2.5 9.2 6.2H7.8L6 8.5v12.5h12V8.5L16.2 6.2h-1.4L12 2.5Z"/><path d="M9.5 8.5h5"/>',
  comment: '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.2 8.4 8.4 0 0 1-3.8-.9L3 21l1.2-4.2A8.4 8.4 0 0 1 3 11.5 8.5 8.5 0 0 1 11.5 3 8.5 8.5 0 0 1 21 11.5Z"/>',
  zoom: '<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>',
  crown: '<path d="M4 18h16M6 16l2.3-8.5 3.2 5.5 2.5-4.5 2.5 4.5 3.2-5.5L18 16"/>',
  filter: '<path d="M4 6h16M7 12h10M10 18h4"/>',
  layers:
    '<path d="m12 3.2-8.5 4.6L12 12.4l8.5-4.6L12 3.2Z"/><path d="m3.5 12.2 8.5 4.6 8.5-4.6"/><path d="m3.5 16.4 8.5 4.6 8.5-4.6"/>',
  chevronDown: '<path d="m6 9 6 6 6-6"/>',
  chevronLeft: '<path d="m15 6-6 6 6 6"/>',
  chevronRight: '<path d="m9 6 6 6-6 6"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  rotateCw: '<path d="M20 10a8 8 0 1 1-2.3-5.6"/><path d="M20 4v6h-6"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="10" r="1.5"/><path d="m21 15-4.5-4.5L9 18"/>',
  moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"/>',
  palette:
    '<path d="M9.5 3.6c-3.9.6-6.7 4.1-6.3 8.1.4 3.5 3.1 5.8 6.2 5.8.9 0 1.5-.4 1.8-1.1.4-.8 1.1-1.4 2.1-1.4h.6c2.9 0 5.3-2.3 5.3-5.3 0-3.7-3.5-6.8-9.7-6.1Z"/>' +
    '<circle cx="7.6" cy="9.2" r="1.15" fill="currentColor" stroke="none"/>' +
    '<circle cx="11.2" cy="7.4" r="1.15" fill="currentColor" stroke="none"/>' +
    '<circle cx="14.4" cy="9.3" r="1.15" fill="currentColor" stroke="none"/>' +
    '<circle cx="10.2" cy="12.2" r="1.15" fill="currentColor" stroke="none"/>' +
    '<path d="M15.8 13.8 19.4 21"/>' +
    '<path d="M15.8 13.8c1.1-.2 2.2.5 2.8 1.4.6.9.6 2 0 2.7"/>',
  sun:
    '<circle cx="12" cy="12" r="4.15" fill="currentColor"/>' +
    '<path fill="currentColor" d="M12.00 2.40 L10.49 5.83 L13.51 5.83Z' +
    'M18.79 5.21 L15.29 6.57 L17.43 8.71Z' +
    'M21.60 12.00 L18.17 10.49 L18.17 13.51Z' +
    'M18.79 18.79 L17.43 15.29 L15.29 17.43Z' +
    'M12.00 21.60 L13.51 18.17 L10.49 18.17Z' +
    'M5.21 18.79 L8.71 17.43 L6.57 15.29Z' +
    'M2.40 12.00 L5.83 13.51 L5.83 10.49Z' +
    'M5.21 5.21 L6.57 8.71 L8.71 6.57Z"/>',
  bell: '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>',
  musicNote:
    '<path d="M9 18V5l11-2v13"/><circle cx="7" cy="18" r="2.5"/><circle cx="18" cy="16" r="2.5"/>',
  settings:
    '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V19a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H5a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V5a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H19a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z"/>',
  pencil: '<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
  eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
  eyeOff:
    '<path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/><path d="M6.2 6.2 4 4"/><path d="M20 20l-2.2-2.2"/><path d="M3 12s3.5-7 10-7c2.1 0 3.9.8 5.3 1.9M21 12s-3.5 7-10 7c-2.1 0-3.9-.8-5.3-1.9"/>',
  pause: '<rect x="6" y="5" width="4" height="14" rx="1.2" fill="currentColor" stroke="none"/><rect x="14" y="5" width="4" height="14" rx="1.2" fill="currentColor" stroke="none"/>',
  play: '<path d="M8 5.5v13l11-6.5Z" fill="currentColor" stroke="none"/>',
  gamepad:
    '<rect x="4" y="8" width="16" height="9" rx="3"/>' +
    '<line x1="7.5" y1="12.5" x2="10.5" y2="12.5"/>' +
    '<line x1="9" y1="10.5" x2="9" y2="14.5"/>' +
    '<circle cx="15.5" cy="11.5" r="1"/>' +
    '<circle cx="17.5" cy="13.5" r="1"/>',
  sceneSetup:
    '<rect x="3" y="5" width="18" height="14" rx="1.5"/>' +
    '<circle cx="9.5" cy="11" r="1.8"/>' +
    '<path d="M7.8 15.2c.5-1.3 1.1-2.2 1.7-2.2s1.2.9 1.7 2.2"/>' +
    '<path d="M16 10.5v5M14 12.5h4"/>',
  templatePanel:
    '<rect x="5" y="4" width="14" height="16" rx="2"/>' +
    '<rect x="7.5" y="7" width="9" height="5" rx="1"/>' +
    '<rect x="7.5" y="14" width="4" height="3" rx=".8"/>' +
    '<rect x="12.5" y="14" width="4" height="3" rx=".8"/>',
  reply: '<path d="M10 8.5 6 12l4 3.5"/><path d="M6 12h8.5a4 4 0 0 0 0-8H10"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.5a1.5 1.5 0 0 1 1.5-1.5h2a1.5 1.5 0 0 1 1.5 1.5V7"/><path d="M7 7l.7 11.5a1 1 0 0 0 1 .9h6.6a1 1 0 0 0 1-.9L17 7"/>',
  /* Instagram-style verified badge (filled disc + check). */
  verified:
    '<circle cx="12" cy="12" r="10" fill="currentColor" stroke="none"/>' +
    '<path fill="none" stroke="var(--surface, #fff)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="m7.2 12.2 3.1 3.1 6.5-6.6"/>',
};

export function icon(name) {
  const path = P[name] || "";
  if (name === "sun") {
    return `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">${path}</svg>`;
  }
  if (name === "leaf" || name === "sparkle" || name === "star") {
    return `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">${path}</svg>`;
  }
  if (name === "verified") {
    return `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">${path}</svg>`;
  }
  return (
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ` +
    `stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${path}</svg>`
  );
}

export function discordIcon() {
  return (
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>' +
    "</svg>"
  );
}

export function episodeIcon() {
  return (
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M4 2.5 6.4 5.5H18a2.5 2.5 0 0 1 2.5 2.5v7A2.5 2.5 0 0 1 18 17.5H11l-3 2.5V17.5H6A2.5 2.5 0 0 1 3.5 15V8A2.5 2.5 0 0 1 6 5.5h.4L4 2.5Z"/>' +
    "</svg>"
  );
}

export function instagramIcon() {
  return (
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M7.5 3h9A4.5 4.5 0 0 1 21 7.5v9a4.5 4.5 0 0 1-4.5 4.5h-9A4.5 4.5 0 0 1 3 16.5v-9A4.5 4.5 0 0 1 7.5 3Zm0 2A2.5 2.5 0 0 0 5 7.5v9A2.5 2.5 0 0 0 7.5 19h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 16.5 5h-9ZM12 8.2A3.8 3.8 0 1 1 8.2 12 3.8 3.8 0 0 1 12 8.2Zm0 2A1.8 1.8 0 1 0 13.8 12 1.8 1.8 0 0 0 12 10.2ZM17.4 7.1a1 1 0 1 1-1 1 1 1 0 0 1 1-1Z"/>' +
    "</svg>"
  );
}

/* The brand cookie mark - a stylized cookie with a nibble + chocolate chips.
   Drawn in espresso tones to sit on the honey logo tile. */
export function brandMark() {
  return (
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    // cookie body with a small nibble notch on the upper-right edge
    '<path fill="#3a2405" d="M12 2.4a9.6 9.6 0 1 0 9.55 10.65 2.5 2.5 0 0 1-2.9-3.35 2.5 2.5 0 0 1-3.2-3.2A2.5 2.5 0 0 1 12.9 2.48 9.7 9.7 0 0 0 12 2.4Z"/>' +
    // chocolate chips
    '<circle cx="8.8" cy="9.6" r="1.25" fill="#7a4c17"/>' +
    '<circle cx="13.4" cy="12.6" r="1.25" fill="#7a4c17"/>' +
    '<circle cx="9.4" cy="14.6" r="1.05" fill="#7a4c17"/>' +
    '<circle cx="11.8" cy="10.8" r="0.85" fill="#7a4c17"/>' +
    "</svg>"
  );
}

/* Cookie only - no honey tile. Used for the landing-page rain effect. */
export function cookieOnly() {
  return (
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path fill="var(--cookie-body, #d98a2b)" d="M12 2.4a9.6 9.6 0 1 0 9.55 10.65 2.5 2.5 0 0 1-2.9-3.35 2.5 2.5 0 0 1-3.2-3.2A2.5 2.5 0 0 1 12.9 2.48 9.7 9.7 0 0 0 12 2.4Z"/>' +
    '<circle cx="8.8" cy="9.6" r="1.25" fill="var(--cookie-chip, #7a4c17)"/>' +
    '<circle cx="13.4" cy="12.6" r="1.25" fill="var(--cookie-chip, #7a4c17)"/>' +
    '<circle cx="9.4" cy="14.6" r="1.05" fill="var(--cookie-chip, #7a4c17)"/>' +
    '<circle cx="11.8" cy="10.8" r="0.85" fill="var(--cookie-chip, #7a4c17)"/>' +
    "</svg>"
  );
}

/** Side-view cookie disc for jar stacks (edge-on pile). */
export function cookieSide(variant = 0) {
  const chips = [
    [[12, 6.4], [21, 5.8], [30, 6.6]],
    [[14, 6.2], [23, 6.8], [32, 5.9]],
    [[10, 6.5], [19, 6], [27, 6.7]],
  ][variant % 3];
  const chipDots = chips
    .map(([cx, cy]) => `<circle cx="${cx}" cy="${cy}" r="1.25" fill="var(--cookie-chip, #6b4423)"/>`)
    .join("");
  return (
    '<svg viewBox="0 0 44 12" aria-hidden="true">' +
    '<ellipse cx="22" cy="6.4" rx="20.5" ry="5.4" fill="var(--cookie-body, #d4a054)" stroke="rgba(90,61,46,0.28)" stroke-width="0.55"/>' +
    '<ellipse cx="22" cy="5.1" rx="16" ry="2" fill="rgba(255,255,255,0.2)"/>' +
    chipDots +
    "</svg>"
  );
}
